import About from "../Pages/About/About";
import ConsultingRequest from "../Pages/ConsultingRequest/ConsultingRequest";
import ContactUs from "../Pages/ContactUs/ContactUs";
import Customers from "../Pages/Customers/Customers";
import Home from "../Pages/Home/Home";
import JobRequest from "../Pages/JobRequest/JobRequest";
import Members from "../Pages/Members/Members";
import News from "../Pages/News/News";
import NewsDetail from "../Pages/News/NewsDetail";
import Newsletter from "../Pages/Newsletter/Newsletter";
import Product from "../Pages/Products/Product";
import Products from "../Pages/Products/Products";
import React from "react";
import { Redirect } from "react-router";
// import DemoRequest from "../components/general/misc/DemoRequest";
import NotFoundPage from "../Pages/NotFoundPage/NotFoundPage";

const baseRoute = {
  exact: true,
};

const customRoute = {
  ...baseRoute,
  // footer: DemoRequest,
};

export const routes = [
  {
    ...baseRoute,
    key: "home",
    path: "/",
    body: Home,
  },
  {
    ...customRoute,
    key: "about",
    path: "/about",
    body: About,
  },
  {
    ...customRoute,
    key: "products",
    path: "/products",
    body: Products,
  },
  {
    ...baseRoute,
    key: "product",
    path: "/products/:id/:slug",
    body: Product,
  },
  {
    ...baseRoute,
    key: "members",
    path: "/members",
    body: Members,
  },
  {
    ...customRoute,
    key: "customers",
    path: "/customers",
    body: Customers,
  },
  {
    ...baseRoute,
    key: "consulting-request",
    path: "/consulting-request",
    body: ConsultingRequest,
  },
  {
    ...baseRoute,
    key: "job-request",
    path: "/job-request",
    body: JobRequest,
  },
  {
    ...customRoute,
    key: "newsletter",
    path: "/newsletter",
    body: Newsletter,
  },
  {
    ...baseRoute,
    key: "contact-us",
    path: "/contact",
    body: ContactUs,
  },
  {
    ...customRoute,
    key: "news",
    path: "/news",
    body: News,
  },
  {
    ...customRoute,
    key: "news-detail",
    path: "/news/:id",
    body: NewsDetail,
  },
  // {
  //   key: "root",
  //   body: () => <Redirect to={"/"} />,
  //   exact: false,
  // },
  {
    ...customRoute,
    key: "not-found",
    path: "*",
    body: NotFoundPage,
  },
];
